// import React, { useState } from 'react';
// import { Copy, Check, Users, Share2, X } from 'lucide-react';
// import { copyToClipboard } from '@/utils';

// interface MeetingHeaderProps {
//   meetingTitle: string;
//   meetingId: string;
//   participantCount: number;
// }

// export const MeetingHeader: React.FC<MeetingHeaderProps> = ({
//   meetingTitle,
//   meetingId,
//   participantCount,
// }) => {
//   const [copied, setCopied] = React.useState(false);
//   const [showShareOptions, setShowShareOptions] = useState(false);

//   const joinUrl = `${window.location.origin}/join?id=${meetingId}`;
//   const shareText = `Join my meeting: ${meetingTitle}`;

//   const handleCopyLink = async () => {
//     const success = await copyToClipboard(joinUrl);
    
//     if (success) {
//       setCopied(true);
//       setTimeout(() => {
//         setCopied(false);
//         setShowShareOptions(false);
//       }, 2000);
//     }
//   };

//   const handleShareWhatsApp = () => {
//     const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${joinUrl}`)}`;
//     window.open(whatsappUrl, '_blank');
//     setShowShareOptions(false);
//   };

//   const handleShareTwitter = () => {
//     const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(joinUrl)}`;
//     window.open(twitterUrl, '_blank');
//     setShowShareOptions(false);
//   };

//   const handleShareEmail = () => {
//     const emailUrl = `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(`Join the meeting here: ${joinUrl}`)}`;
//     window.location.href = emailUrl;
//     setShowShareOptions(false);
//   };

//   const handleShareTelegram = () => {
//     const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(joinUrl)}&text=${encodeURIComponent(shareText)}`;
//     window.open(telegramUrl, '_blank');
//     setShowShareOptions(false);
//   };

//   return (
//     <div className="bg-neutral-900 border-b border-white/10 px-4 sm:px-6 py-3 sm:py-4">
//       <div className="flex items-center justify-between max-w-7xl mx-auto gap-3">
//         {/* Left: Title & Participants */}
//         <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 min-w-0 flex-1">
//           <h1 className="text-base sm:text-xl font-semibold text-white truncate">
//             {meetingTitle}
//           </h1>
//           <div className="flex items-center gap-1.5 text-xs sm:text-sm text-neutral-400">
//             <Users size={14} className="hidden sm:block" />
//             <span>{participantCount} participant{participantCount !== 1 && 's'}</span>
//           </div>
//         </div>

//         {/* Right: Share Options Container */}
//         <div className="flex items-center gap-2 overflow-hidden">
//           {/* Share Options - Slide from right */}
//           <div
//             className={`flex items-center gap-2 transition-all duration-300 ease-in-out ${
//               showShareOptions
//                 ? 'opacity-100 translate-x-0'
//                 : 'opacity-0 translate-x-full pointer-events-none'
//             }`}
//           >
//             {/* Copy Link */}
//             <button
//               onClick={handleCopyLink}
//               className="flex items-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all text-white text-sm whitespace-nowrap"
//               title="Copy Link"
//             >
//               {copied ? (
//                 <Check size={16} className="text-green-400" />
//               ) : (
//                 <Copy size={16} />
//               )}
//               <span className="hidden sm:inline">{copied ? 'Copied!' : 'Copy'}</span>
//             </button>

//             {/* WhatsApp */}
//             <button
//               onClick={handleShareWhatsApp}
//               className="p-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all"
//               title="Share on WhatsApp"
//             >
//               <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
//               </svg>
//             </button>

//             {/* Twitter/X */}
//             <button
//               onClick={handleShareTwitter}
//               className="p-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all"
//               title="Share on X"
//             >
//               <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
//               </svg>
//             </button>

//             {/* Telegram */}
//             <button
//               onClick={handleShareTelegram}
//               className="p-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all"
//               title="Share on Telegram"
//             >
//               <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
//               </svg>
//             </button>

//             {/* Email */}
//             <button
//               onClick={handleShareEmail}
//               className="p-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all"
//               title="Share via Email"
//             >
//               <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//               </svg>
//             </button>

//             {/* Close Button */}
//             <button
//               onClick={() => setShowShareOptions(false)}
//               className="p-2 bg-red-500/20 hover:bg-red-500/30 border border-red-500/30 rounded-lg transition-all"
//               title="Close"
//             >
//               <X size={16} className="text-red-400" />
//             </button>
//           </div>

//           {/* Share Button - Trigger */}
//           <button
//             onClick={() => setShowShareOptions(!showShareOptions)}
//             className={`flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all text-white text-sm whitespace-nowrap ${
//               showShareOptions ? 'opacity-0 pointer-events-none' : 'opacity-100'
//             }`}
//           >
//             <Share2 size={16} />
//             <span className="hidden sm:inline">Share</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useState } from 'react';
import { Copy, Check, Users, Share2, X, Clock, AlertCircle } from 'lucide-react';
import { copyToClipboard } from '@/utils';

interface MeetingHeaderProps {
  meetingTitle: string;
  meetingId: string;
  participantCount: number;
  // Timer props (optional - only show for free tier)
  timeRemaining?: number | null;
  formattedTime?: string;
  isInGracePeriod?: boolean;
  tier?: 'free' | 'pro' | 'enterprise';
  progress?: number;
}

export const MeetingHeader: React.FC<MeetingHeaderProps> = ({
  meetingTitle,
  meetingId,
  participantCount,
  timeRemaining,
  formattedTime,
  isInGracePeriod,
  tier,
  progress,
}) => {
  const [copied, setCopied] = React.useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);

  const joinUrl = `${window.location.origin}/join?id=${meetingId}`;
  const shareText = `Join my meeting: ${meetingTitle}`;

  const handleCopyLink = async () => {
    const success = await copyToClipboard(joinUrl);
    
    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        setShowShareOptions(false);
      }, 2000);
    }
  };

  const handleShareWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${joinUrl}`)}`;
    window.open(whatsappUrl, '_blank');
    setShowShareOptions(false);
  };

  const handleShareTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(joinUrl)}`;
    window.open(twitterUrl, '_blank');
    setShowShareOptions(false);
  };

  const handleShareEmail = () => {
    const emailUrl = `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(`Join the meeting here: ${joinUrl}`)}`;
    window.location.href = emailUrl;
    setShowShareOptions(false);
  };

  const handleShareTelegram = () => {
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(joinUrl)}&text=${encodeURIComponent(shareText)}`;
    window.open(telegramUrl, '_blank');
    setShowShareOptions(false);
  };

  // Timer color logic
  const getTimerColorClass = () => {
    if (isInGracePeriod) return 'text-red-500 bg-red-500/10 border-red-500/30';
    if (timeRemaining !== undefined && timeRemaining !== null && timeRemaining <= 5) return 'text-orange-500 bg-orange-500/10 border-orange-500/30';
    if (timeRemaining !== undefined && timeRemaining !== null && timeRemaining <= 10) return 'text-yellow-500 bg-yellow-500/10 border-yellow-500/30';
    return 'text-neutral-400 bg-neutral-800 border-neutral-700';
  };

  // Show timer only for free tier with time remaining
  const showTimer = tier === 'free' && timeRemaining !== undefined && timeRemaining !== null;

  return (
    <div className="bg-neutral-900 border-b border-white/10 px-4 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between max-w-7xl mx-auto gap-3">
        {/* Left: Title & Participants */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 min-w-0 flex-1">
          <h1 className="text-base sm:text-xl font-semibold text-white truncate">
            {meetingTitle}
          </h1>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5 text-xs sm:text-sm text-neutral-400">
              <Users size={14} className="hidden sm:block" />
              <span>{participantCount} participant{participantCount !== 1 && 's'}</span>
            </div>

            {/* Timer Display */}
            {showTimer && (
              <div className={`flex items-center gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg border transition-all ${getTimerColorClass()}`}>
                {isInGracePeriod ? (
                  <AlertCircle size={14} className="animate-pulse" />
                ) : (
                  <Clock size={14} />
                )}
                <div className="flex items-center gap-1">
                  <span className="text-xs font-medium hidden sm:inline">
                    {isInGracePeriod ? 'Grace:' : 'Time:'}
                  </span>
                  <span className="text-xs sm:text-sm font-bold font-mono">{formattedTime}</span>
                </div>
                
                {/* Progress bar - desktop only */}
                {!isInGracePeriod && (
                  <div className="hidden sm:block w-12 h-1.5 bg-black/20 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-current transition-all duration-1000"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Right: Share Section */}
        <div className="relative flex items-center">
          {/* Share Button - Always visible */}
          <button
            onClick={() => setShowShareOptions(!showShareOptions)}
            className={`flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg transition-all text-white text-sm whitespace-nowrap z-10 ${
              showShareOptions ? 'bg-white/20' : ''
            }`}
          >
            <Share2 size={16} />
            <span className="hidden sm:inline">Share</span>
          </button>

          {/* Share Options Dropdown - Absolute positioned */}
          {showShareOptions && (
            <div className="absolute right-0 top-full mt-2 bg-neutral-800 border border-white/10 rounded-lg shadow-2xl p-2 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
              <div className="flex flex-col gap-1 min-w-[200px]">
                {/* Copy Link */}
                <button
                  onClick={handleCopyLink}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all text-white text-sm"
                >
                  {copied ? (
                    <>
                      <Check size={16} className="text-green-400" />
                      <span className="text-green-400">Copied!</span>
                    </>
                  ) : (
                    <>
                      <Copy size={16} />
                      <span>Copy Link</span>
                    </>
                  )}
                </button>

                {/* WhatsApp */}
                <button
                  onClick={handleShareWhatsApp}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all text-white text-sm"
                >
                  <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  <span>WhatsApp</span>
                </button>

                {/* Twitter/X */}
                <button
                  onClick={handleShareTwitter}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all text-white text-sm"
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                  <span>X (Twitter)</span>
                </button>

                {/* Telegram */}
                <button
                  onClick={handleShareTelegram}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all text-white text-sm"
                >
                  <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                  <span>Telegram</span>
                </button>

                {/* Email */}
                <button
                  onClick={handleShareEmail}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-white/10 rounded-lg transition-all text-white text-sm"
                >
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>Email</span>
                </button>

                <div className="border-t border-white/10 my-1" />

                {/* Close */}
                <button
                  onClick={() => setShowShareOptions(false)}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-red-500/20 rounded-lg transition-all text-red-400 text-sm"
                >
                  <X size={16} />
                  <span>Close</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};